import React from "react"

const Divider = ({
  variant = "dashed",
  width = "full",
  orientation = "horizontal",
  noMargin = false,
  noTopMargin = false,
  noBottomMargin = false,
  className = "",
}) => {
  const classes = ["divider", className].filter(Boolean)

  if (variant === "dashed") {
    if (orientation === "vertical") {
      classes.push("divider--vertical-dashed")
      return <div aria-hidden="true" className={classes.join(" ")} />
    }

    classes.push("divider--dashed")

    if (width === "1240") classes.push("divider--dashed--1240")
    if (width === "140") classes.push("divider--dashed--140")
    if (noMargin) classes.push("divider--no-margin")
    if (noTopMargin) classes.push("divider--no-top-margin")

    if (noBottomMargin) classes.push("divider--no-bottom-margin")

    const hr = <hr aria-hidden="true" className={classes.join(" ")} />

    // Some parent layouts (e.g. flex) can interfere with `margin: auto` centering.
    // We keep callsites wrapper-free, but center constrained variants reliably.
    if (width === "1240" || width === "140") {
      return (
        <div aria-hidden="true" className="divider__center">
          {hr}
        </div>
      )
    }

    return hr
  }

  return <hr aria-hidden="true" className={classes.join(" ")} />
}

export default Divider
